// import React, { useRef } from "react";
// import {
//   motion,
//   useScroll,
//   useVelocity,
//   useTransform,
//   useSpring,
// } from "framer-motion";
// import classes from "./velocityText.module.css";

// export const VelocityText = () => {
//   const targetRef = useRef(null);

//   const { scrollYProgress } = useScroll({
//     target: targetRef,
//     offset: ["start start", "end start"],
//   });

//   const scrollVelocity = useVelocity(scrollYProgress);

//   const skewXRaw = useTransform(
//     scrollVelocity,
//     [-0.5, 0.5],
//     ["45deg", "-45deg"]
//   );
//   const skewX = useSpring(skewXRaw, { mass: 3, stiffness: 400, damping: 50 });

//   const xRaw = useTransform(scrollYProgress, [0, 1], [0, -4000]);
//   const x = useSpring(xRaw, { mass: 3, stiffness: 400, damping: 50 });

//   return (
//     <section ref={targetRef} className={classes.container}>
//       <div className={classes.stickyContainer}>
//         <motion.p style={{ skewX, x }} className={classes.text}>
//           Do you have what it takes to be the best artist in the world? Compete
//           with other artists to find out!
//         </motion.p>
//       </div>
//     </section>
//   );
// };
import React, { useState, useRef, useEffect } from "react";
import classes from "./velocityText.module.css";

export const VelocityText = () => {
  const containerRef = useRef(null);
  const textRefs = useRef({});
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  const textContent = [
    { text: "Do ", key: "text1" },
    { text: "you ", key: "text2" },
    { text: "have ", key: "text3" },
    { text: "what ", key: "text4" },
    { text: "it ", key: "text5" },
    { text: "takes ", key: "text6" },
    { text: "to ", key: "text7" },
    { text: "be ", key: "text8" },
    { text: "the ", key: "text9" },
    { text: "best ", key: "text10" },
    { text: "artist ", key: "text11" },
    { text: "in ", key: "text12" },
    { text: "the ", key: "text13" },
    { text: "world? ", key: "text14" },
    { text: "Compete ", key: "text15" },
    { text: "with ", key: "text16" },
    { text: "other ", key: "text17" },
    { text: "artists ", key: "text18" },
    { text: "to ", key: "text19" },
    { text: "find ", key: "text20" },
    { text: "out!", key: "text21" },
  ];

  const handleMouseMove = (e) => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect();
      const newPosition = {
        x: e.clientX - rect.left,
        y: e.clientY - rect.top,
      };
      setMousePosition(newPosition);

      // Check each text span's position relative to light
      Object.keys(textRefs.current).forEach((key) => {
        const textElement = textRefs.current[key];
        if (textElement) {
          const textRect = textElement.getBoundingClientRect();
          const textCenterX = textRect.left + textRect.width / 2 - rect.left;
          const textCenterY = textRect.top + textRect.height / 2 - rect.top;

          // Calculate distance between text center and light center
          const distance = Math.sqrt(
            Math.pow(textCenterX - newPosition.x, 2) +
              Math.pow(textCenterY - newPosition.y, 2)
          );

          // Light radius is around 150px (half of the light effect width)
          if (distance < 150) {
            textElement.classList.add(classes.highlighted);
          } else {
            textElement.classList.remove(classes.highlighted);
          }
        }
      });
    }
  };

  return (
    <div
      ref={containerRef}
      className={classes.container}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => {
        setIsHovering(false);
        // Reset all highlights when mouse leaves
        Object.keys(textRefs.current).forEach((key) => {
          if (textRefs.current[key]) {
            textRefs.current[key].classList.remove(classes.highlighted);
          }
        });
      }}
    >
      <div
        className={classes.lightEffect}
        style={{
          opacity: isHovering ? 1 : 0,
          left: `${mousePosition.x}px`,
          top: `${mousePosition.y}px`,
        }}
      />
      <div className={classes.textContainer}>
        <p className={classes.text}>
          {textContent.map((item) => (
            <span
              key={item.key}
              className={classes.textSpan}
              ref={(el) => (textRefs.current[item.key] = el)}
            >
              {item.text}
            </span>
          ))}
        </p>
      </div>
    </div>
  );
};
